function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M0 32v-3c0-4.484 5.649-6.179 13.1-6.862-1.636-1.014-2.92-3.864-3.589-6.14l-.01.002c-.068 0-1.5-1.791-1.5-4 0-1.938-.138-3.554 1.01-3.92-.001-.027-.007-.053-.007-.08a6.982 6.982 0 0 1 3.187-5.859C12.686.906 14.191 0 16.004 0s3.318.906 3.813 2.141A6.982 6.982 0 0 1 23.004 8c0 .027-.006.053-.007.08 1.145.366 1.01 1.982 1.01 3.92 0 2.209-1.588 4-1.5 4l-.01-.002c-.669 2.275-1.953 5.126-3.589 6.14 7.45.683 13.1 2.315 13.1 6.862v3h-32" /></svg>;
});